module.exports = __webpack_public_path__ + "media/images/massage/cover-desktop@2x-ad14019e6676f45b31d836012cbcd5ac.jpg";